import { render, staticRenderFns } from "./IaCorrectiveActionReport.vue?vue&type=template&id=4cbc4795&scoped=true&"
import script from "./IaCorrectiveActionReport.vue?vue&type=script&lang=js&"
export * from "./IaCorrectiveActionReport.vue?vue&type=script&lang=js&"
import style0 from "./IaCorrectiveActionReport.vue?vue&type=style&index=0&id=4cbc4795&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc4795",
  null
  
)

export default component.exports